import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cart/cartSlice.js";
import ordersReducer from "./order/orderSlice";
import authReducer from "./auth/authSlice";
import serviceReducer from "./service/serviceSlice";
import quickReducer from "./quickService/quickSlice.js";
import { loadFromStorage, saveToStorage } from "./storage.js";
import searchReducer from "./search/searchSlice.js";
import subServicesReducer from "./subservice/subServiceSlice.js";

const preloadedState = {
  cart: loadFromStorage("ramu_cart", (d) => Array.isArray(d.items)),
};

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    order: ordersReducer,
    auth: authReducer,
    services: serviceReducer,
    quickServices: quickReducer,
    subServices: subServicesReducer,
    search: searchReducer,
  },
  preloadedState,
});

store.subscribe(() => {
  const state = store.getState();

  saveToStorage("ramu_cart", state.cart);
  saveToStorage("ramu_orders", state.order);
});
export default store;
